import React, { useEffect, useState } from 'react'
import '../pages/pages.css'
import { NavLink } from "react-router";
import cd from '../assets/cd.jpg'

const Home = () => {


  return (
    <div  id='home'>
        {/* <span  id="home-title">joshua popp</span> */}
        <div id='header-title'>
            <NavLink to="/">josh popp</NavLink>
        </div>
        <div  id='home-navigation'>
            <NavLink className={"nav-link"} to="/development" end>
                projects
            </NavLink>
            <NavLink className={"nav-link"} to="/about" end>
                about
            </NavLink>
        </div>
        <div className='spin-container'>
            <img className={"spin-forever"} src={cd}></img>
        </div>
    </div>
  )
}

export default Home